import { setCartIcon } from "./shopping_cart";

// for manipulating cart's look
let warenkorbMain = document.getElementById("warenkorb");
let warenkorbWrap = document.getElementById("warenkorb-wrap");
let warenkorbHeadline = document.getElementById("warenkorb-headline");
let paypalButtonWrap = document.getElementById("paypal-button-wrap");

// for inserting entries
let cartContainer = document.getElementById("cart-container");
let insertBefore = document.getElementById("insert-before");

let shopEntryTemplate;
let allEntries = [];

let totalAmountNode = document.getElementById("anzahl");
let totalPriceNode = document.getElementById("gesamt");

let btnClear = document.getElementById("clear-warenkorb");
let btnSubmit = document.getElementById("submit-warenkorb");

let totalPrice = 0.0;

let ppBtnPressed = false;

// calc all price and amount values
//update
function setCartValues() {
    // reset values
    booksInCart = 0;
    totalPrice = 0;

    // debugger

    if (berenbergCart.items.length == 0) {
        console.log("Empty Card to set");
    } else {
        for (let i = 0; i < berenbergCart.items.length; i++) {
            // set total prices

            // booksInCart += parseInt(berenbergCart.items[i].amount);
						// debugger
            // booksInCart = berenbergCart.items.reduce((acc, curr) => { 
						// 	if (curr.id == 'VERSAND') {return acc} else {
						// 		return acc+curr.amount;
						// 	}}, 0);
            booksInCart = berenbergCart.items.reduce((acc, curr) => curr.id == 'VERSAND' ? acc : acc+curr.amount, 0);


            totalPrice +=
                parseInt(berenbergCart.items[i].amount) *
                parseFloat(berenbergCart.items[i].price);

            // debugger

            // set single entry prices

            // if( title != "versand") {

						calculateAddAndRemoveShipping(totalPrice);

            // }
            allEntries[i].querySelector("#single-count").innerHTML =
                berenbergCart.items[i].amount + " Stück";
            allEntries[i].querySelector("#total-price").innerHTML =
                "EUR " +
                parseFloat(
                    berenbergCart.items[i].price * berenbergCart.items[i].amount
                ).toFixed(2);
        }
				// debugger

				// calculateAddAndRemoveShipping(totalPrice);
    }

    // change HTML
    totalAmountNode.innerHTML = booksInCart + " Exemplare";
    totalPriceNode.innerHTML = "EUR " + parseFloat(totalPrice).toFixed(2);

    // update cart icons in nav and update local storage accordingly
    setCartIcon();
    localStorage.setItem("berenbergCart", JSON.stringify(berenbergCart));
}

// add book amount
function addBookAmount(id) {
    // debugger
    return function () {
        for (let i = 0; i < berenbergCart.items.length; i++) {
            if (berenbergCart.items[i].id == id) {
                berenbergCart.items[i].amount++;
                setCartValues();
                // calculateAndAddShipping();
            }
        }
    };
}

// remove book amount
function remBookAmount(id) {
    // debugger
    return function () {
        for (let i = 0; i < berenbergCart.items.length; i++) {
            if (
                berenbergCart.items[i].id == id &&
                berenbergCart.items[i].amount > 1
            ) {
                berenbergCart.items[i].amount--;
                setCartValues();
                // calculateAndAddShipping();
                // setView();
            }
        }
    };
}

// delete entry
function delBook(id) {
    return function () {
        if (berenbergCart.items.length < 2) {
            clearWarenkorb();
            return;
        }

        for (let i = 0; i < berenbergCart.items.length; i++) {
            if (berenbergCart.items[i].id == id) {
                allEntries[i].classList.add("shop-entry__hide");

                setTimeout(() => {
                    berenbergCart.items.splice(i, 1);
                    allEntries[i].remove();
                    allEntries.splice(i, 1);
                    // calculateAndAddShipping();
                    // setView();
										debugger
                    setCartValues();
                }, 500);
            }
        }
    };
}

// delete cart, reset arrays, delete local storage
function clearWarenkorb() {
    console.log("Warenkorb löschen …");

    collapseWarenkorb();

    setTimeout(() => {
        deleteLocalStorage();

        // remove div, change headline text, scroll to headline
        warenkorbMain.remove();
        showHeadline("Ihr Warenkorb ist leer.");
    }, 1000);
}

// submit order, render PP Buttons and show them
function submitWarenkorb() {
    // prevent double clicks
    if (ppBtnPressed) return;
    ppBtnPressed = true;
    console.log("Warenkorb jetzt bestellen …");

    collapseWarenkorb();

    // redner PayPal Buttons
    renderPPBtn();

    setTimeout(() => {
        // remove cart and hide headline
        warenkorbWrap.remove();

        // show headline with new text
        showHeadline("Bitte wählen Sie Ihre Zahlungsmethode");

        // show buttons
        paypalButtonWrap.classList.add("show");
    }, 1000);
}

// do if order is complete
function orderComplete() {
    // remove PayPal Buttons
    paypalButtonWrap.remove();

    // hide headline
    warenkorbHeadline.classList.add("hide");

    setTimeout(() => {
        deleteLocalStorage();
        warenkorbMain.remove();
        showHeadline("Vielen Dank für Ihre Bestellung.");
    }, 1000);
}

// do if order failed
function orderFailed() {
    // remove PayPal Buttons
    paypalButtonWrap.remove();

    // hide headline
    warenkorbHeadline.classList.add("hide");

    setTimeout(() => {
        deleteLocalStorage();
        warenkorbMain.remove();
        showHeadline(
            "Es gab einen Fehler bei Ihrer Bestellung. Bitte versuchen Sie es noch einmal."
        );
    }, 1000);
}

// helper functions
function showHeadline(text) {
    warenkorbHeadline.classList.remove("hide");
    warenkorbHeadline.innerHTML = text;
    warenkorbHeadline.scrollIntoView({ block: "end" });
}

// delete local storage and reset all arrays
function deleteLocalStorage() {
    // remove all entries from array
    for (let i = 0; i < allEntries.length; i++) {
        allEntries[i].remove();
    }

    // reset arrrays
    allEntries = null;
    berenbergCart = { items: [] };

    // delete local storage
    setCartValues();
}

// collapse cart and hide headline
function collapseWarenkorb() {
    // collapse cart and hide headline
    warenkorbWrap.classList.add("hide");
    warenkorbHeadline.classList.add("hide");
    warenkorbHeadline.scrollIntoView({ block: "end" });
}

// render the PP Buttons
function renderPPBtn() {
    paypal
        .Buttons({
            // Call your server to set up the transaction
            createOrder: function (data, actions) {
                return fetch("/checkout/api/paypal/order/create/", {
                    method: "post",
                    headers: {
                        "X-CSRF-Token": token,
                    },
                    body: localStorage.getItem("berenbergCart"),
                })
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function (orderData) {
                        console.log(orderData);
                        orderData = orderData.result;
                        return orderData.id;
                    });
            },

            // Call your server to finalize the transaction
            onApprove: function (data, actions) {
                let path =
                    "/checkout/api/paypal/order/" + data.orderID + "/capture/";
                // console.log("this is the path", path);
                return fetch(path, {
                    method: "post",
                    headers: {
                        "X-CSRF-Token": token,
                    },
                })
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function (orderData) {
                        orderData = orderData.result;

                        var errorDetail =
                            Array.isArray(orderData.details) &&
                            orderData.details[0];

                        if (
                            errorDetail &&
                            errorDetail.issue === "INSTRUMENT_DECLINED"
                        ) {
                            return actions.restart();
                        }

                        if (errorDetail) {
                            var msg =
                                "Sorry, your transaction could not be processed.";
                            if (errorDetail.description)
                                msg += "\n\n" + errorDetail.description;
                            if (orderData.debug_id)
                                msg += " (" + orderData.debug_id + ")";
                            orderFailed();
                            // return alert(msg); // Show a failure message (try to avoid alerts in production environments)
                        }

                        // Successful capture! For demo purposes:
                        // console.log(
                        //     "Capture result",
                        //     orderData,
                        //     JSON.stringify(orderData, null, 2)
                        // );
                        var transaction =
                            orderData.purchase_units[0].payments.captures[0];

                        orderComplete();
                    });
            },
        })
        .render("#paypal-button-container");
}

// add listeners to all buttons
function addListeners() {
    btnClear.addEventListener("click", clearWarenkorb);
    btnSubmit.addEventListener("click", submitWarenkorb);
}

// render all html to DOM
// initial load
function setView() {
    if (berenbergCart.items.length < 1) {
        console.log("Card is empty, no items in Warenkorb");
        showHeadline("Ihr Warenkorb ist leer");
        warenkorbMain.remove();
        return;
    } else {
        console.log("There are: ", booksInCart, " items in Warenkorb.");

        // get html template
        var templateHtml = document.getElementsByClassName("shop-entry");

        // create js clone of template
        shopEntryTemplate = templateHtml[0].cloneNode(true);

				// TODO Artikel löscen

        // remove template
        templateHtml[0].remove();

        // calculateAndAddShipping();

        // create nodes
        for (let i = 0; i < berenbergCart.items.length; i++) {
					// console.log(berenbergCart.items[i].id);
					if(berenbergCart.items[i].id == 'VERSAND') {
						berenbergCart.items.splice(i, 1);
						continue;
					}
            addEntryToCartlist(
                berenbergCart.items[i].author,
                berenbergCart.items[i].title,
                berenbergCart.items[i].amount,
                berenbergCart.items[i].price,
                berenbergCart.items[i].id
            );
        }
    }

    // finally set total values
    setCartValues();
}

// create html entries of books in cart
function addEntryToCartlist(author, title, amount, priceSingle, id) {
    let newNode = shopEntryTemplate.cloneNode(true);

    newNode.querySelector("#author").innerHTML = author;
    newNode.querySelector("#title").innerHTML = title;

    newNode.querySelector("#single-count").innerHTML = amount + " Stück";
    newNode.querySelector("#single-price").innerHTML =
        "EUR " + parseFloat(priceSingle).toFixed(2);
    newNode.querySelector("#total-price").innerHTML =
        "EUR " + parseFloat(priceSingle * amount).toFixed(2);

    // add controls
    newNode
        .querySelector("#btn-add")
        .addEventListener("click", addBookAmount(id));
    newNode
        .querySelector("#btn-rem")
        .addEventListener("click", remBookAmount(id));
    newNode.querySelector("#btn-del").addEventListener("click", delBook(id));

    // console.log(title);

    // if (title != "versand") {
    // 	console.log("its not versand");

    // 	newNode.querySelector("#btn-add").addEventListener("click", addBookAmount(id));
    // 	newNode.querySelector("#btn-rem").addEventListener("click", remBookAmount(id));
    // 	newNode.querySelector("#btn-del").addEventListener("click", delBook(id));

    // } else {
    // 	// debugger
    // 	newNode.querySelectorAll(".shop-entry__btn-rect").forEach(e => e.remove());
    // 	// newNode.querySelector("h5.shop-entry__count").remove();
    // 	newNode.querySelector("a#btn-del").remove();
    // }

    allEntries.push(newNode);
    cartContainer.insertBefore(newNode, insertBefore);
}

function calculateAddAndRemoveShipping(totalPrice) {
    console.log("calculating shipping", totalPrice);

    const shippingRate = 3;
		const shippingEntry = {
			id: "VERSAND",
			amount: 1,
			isbn: "111111",
			title: "versand",
			price: shippingRate.toString(),
			author: "Bei einem Bestellwert unter 20€"
		}
    // debugger

    // const price = berenbergCart.items.reduce((acc, curr) => {
    //     return acc + curr.amount * parseFloat(curr.price);
    // }, 0);

    const shippingPos = berenbergCart.items.findIndex(
        (e) => e.id === "VERSAND"
    );

		//remove shipping when cart is empty
    if (shippingPos == 0 && berenbergCart.items.length == 1) {
        berenbergCart.items.splice(shippingPos, 1);
				clearWarenkorb();
        return;
    }

    // debugger

		// has no shipping and is more thatn 20
		if(totalPrice >= 20 && shippingPos == -1) return;
		// has no shipping and is less than 20
		if(totalPrice <= 20 && shippingPos == -1) {
			// add to browser cart
			berenbergCart.items.push(shippingEntry);
			addShippingEntry(shippingEntry);
		}
		// has shipping and is more than 20
		if (totalPrice >= 20 + shippingRate) {
			// delete berenbergCart.items[shippingPos];
			berenbergCart.items.splice(shippingPos, 1);
			allEntries.at(-1).remove();
		}
		// has shipping in wrong pos
		if(totalPrice <= 20 + shippingRate && shippingPos != berenbergCart.items.length-1) {
        // has shipping in wrong position
        const ship = berenbergCart.items.splice(shippingPos, 1)[0];
        berenbergCart.items.push(ship);
				// setCartValues();
    }

    // console.log(berenbergCart);
		// debugger

    // if (berenbergCart.items.findIndex(e => e.id === 'VERSAND')) {
    // 	if (berenbergCart.item.at(-1).id != 'VERSAND')
    // 	return;
    // }
}

function addShippingEntry(entryObj) {
    let newNode = shopEntryTemplate.cloneNode(true);

		const {author, title, amount, isbn, price } = entryObj;
		
    newNode.querySelector("#author").innerHTML = author;
    newNode.querySelector("#title").innerHTML = title;

    newNode.querySelector("#single-count").innerHTML = amount + " Stück";
    newNode.querySelector("#single-price").innerHTML =
        "EUR " + parseFloat(price).toFixed(2);
    newNode.querySelector("#total-price").innerHTML =
        "EUR " + parseFloat(price).toFixed(2);

    // console.log(title);

    // debugger
    newNode
        .querySelectorAll(".shop-entry__btn-rect")
        .forEach((e) => e.remove());
    // newNode.querySelector("h5.shop-entry__count").remove();
    newNode.querySelector("a#btn-del").remove();

    allEntries.push(newNode);
    cartContainer.insertBefore(newNode, insertBefore);
}

function interactive() {}

function complete() {
    setView();
    addListeners();
}

document.addEventListener("readystatechange", (event) => {
    switch (document.readyState) {
        case "loading":
            break;
        case "interactive":
            interactive();
            break;
        case "complete":
            complete();
            break;
    }
});
